import { render, staticRenderFns } from "./FormPlanClient.vue?vue&type=template&id=5138a42a"
import script from "./FormPlanClient.vue?vue&type=script&lang=js"
export * from "./FormPlanClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports